import throttle from 'lodash/throttle';

class InpageMenu {
	constructor() {
		this.header = document.querySelector('.main-header');
		this.alertBar = document.querySelector('.alert-bar');
		this.wpadminbar = document.querySelector('#wpadminbar');

		this.mobileBtn = document.querySelector(
			'.block-inpage-menu__mobile-toggle'
		);
		this.nav = document?.querySelector('.block-inpage-menu');
		this.navigationMenu = this.nav?.querySelector(
			'.block-inpage-menu__list'
		);
		this.navLinks = this.navigationMenu?.querySelectorAll(
			'.block-inpage-menu__link'
		);
		this.viewportTopOffset = 0;
		this.anchorTargets = [];
		this.activeSection = '';
		this.mobileActiveSectionText = this.nav.querySelector(
			'.block-inpage-menu__mobile-toggle span:first-child'
		);
		this.disableScrollEvents = false;

		window.addEventListener('load', () => {
			this.init();
		});
	}

	init() {
		this.getViewportTopOffset();
		this.hideInvalidLinks();

		// Add link hrefs to array and add link click listeners
		if (this.navLinks) {
			this.navLinks.forEach((link) => {
				const href = link.getAttribute('href');

				if (href && '#' !== href && href[0] === '#') {
					const hrefs = document.querySelectorAll(href);

					if (hrefs.length > 0) {
						this.anchorTargets.push(hrefs[0]);

						link.addEventListener('click', (e) => {
							this.navLinkClick(e);
						});
					}
				}
			});
		}

		// Mobile button toggle click listener
		this.mobileBtn?.addEventListener('click', (e) => {
			this.toggleDropdown(e);
		});

		// Window scroll listener
		window.addEventListener(
			'scroll',
			throttle(this.checkElementsPositions.bind(this), 100)
		);

		// Listen for smooth scroll anchor complete custom event
		window.addEventListener('anchorScrollComplete', () => {
			this.disableScrollEvents = false;
		});
	}

	getViewportTopOffset = () => {
		const headerHeight =
			document.querySelector('.main-header')?.offsetHeight || 0;
		const utilityMenuHeight =
			document.querySelector('.utility-menu')?.offsetHeight || 0;
		const alertBarHeight =
			document.querySelector('.block-alert-top')?.offsetHeight || 0;
		const inpageMenuHeight =
			document.querySelector('.block-inpage-menu')?.offsetHeight || 0;
		const adminBarHeight =
			document.getElementById('wpadminbar')?.offsetHeight || 0;

		this.viewportTopOffset =
			adminBarHeight +
			alertBarHeight +
			headerHeight +
			inpageMenuHeight +
			utilityMenuHeight;
	};

	checkElementsPositions = () => {
		if (this.disableScrollEvents) {
			return;
		}

		// Loop through anchor targets and identify the active one
		this.anchorTargets.forEach((target) => {
			const rect = target.getBoundingClientRect();
			if (
				rect.top - window.innerHeight <
					(window.innerHeight - this.viewportTopOffset) / -2 &&
				rect.bottom - this.viewportTopOffset > 0
			) {
				if (target.id !== this.activeSection) {
					this.activeSection = target.id;
				}
			}
		});

		if (this.activeSection !== '') {
			const link = this.nav.querySelector(
				'[href="#' + this.activeSection + '"]'
			);

			this.removeAllLinksActive();
			this.setLinkActive(link.parentNode);
			this.setDropdownText(link);
		}
	};

	removeAllLinksActive = () => {
		this.navLinks.forEach((link) => {
			link.parentNode.classList.remove('active');
		});
	};

	setLinkActive = (link) => {
		link.classList.add('active');
	};

	setDropdownText = (link) => {
		this.mobileActiveSectionText.innerText = link.innerText;
	};

	toggleDropdown = (e) => {
		this.mobileBtn.classList.toggle('open');

		if (this.mobileBtn.classList.contains('open')) {
			document.addEventListener('click', this.closeDropdown);
			document.addEventListener('keydown', this.closeDropdown);
		} else {
			document.removeEventListener('click', this.closeDropdown);
			document.removeEventListener('keydown', this.closeDropdown);
		}

		e.stopPropagation();
	};

	closeDropdown = (e) => {
		if ('Escape' === e.key || undefined === e.key) {
			this.mobileBtn.classList.remove('open');
			document.removeEventListener('click', this.closeDropdown);
			document.removeEventListener('keydown', this.closeDropdown);
		}
	};

	navLinkClick(e) {
		e.preventDefault();

		this.disableScrollEvents = true;

		const link = e.target.closest('.block-inpage-menu__link');

		if (this.mobileActiveSectionText) {
			this.removeAllLinksActive();
			this.setLinkActive(link);
			this.setDropdownText(e.target);
		}
	}

	// Remove links with href that does not correspond to an existing anchor id
	hideInvalidLinks() {
		document
			.querySelectorAll('.block-inpage-menu__list-item a[href^="#"]')
			.forEach(function (aTag) {
				const targetId = aTag.getAttribute('href').slice(1); // remove the '#' at the start
				const targetElement = targetId
					? document.getElementById(targetId)
					: null;

				if (!targetElement) {
					// Automatic links wrap the <a> in a button div, so hide the list item rather than the direct parent.
					aTag.closest('.block-inpage-menu__list-item').classList.add(
						'hidden'
					);
				}
			});
	}
}

const InpageMenuInstance = new InpageMenu();
